
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/wallet-sdk",
      function () {
        return require("private-next-pages/products/wallet-sdk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/wallet-sdk"])
      });
    }
  